import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../selectors/getOnsaCurrentProductSelector';
import { useAsyncThrow } from '../../hooks/useAsyncThrow';
import type {
    CoverableOnsaDTO,
    CoveragePackageInformationToUpdateDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import {
    getCoveragePackageFieldsToUpdate,
    getLobToUpdate,
    getOnsaCoverable
} from '../../utils/coverablesUtil';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';

export function useUpdateCoveragePackageInformation<T extends CoverableOnsaDTO>(): {
    updateCoveragePackageInformation: (propertyToUpdate: Partial<T>) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { flavourName, fixedId, lobCode } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId);
    const { asyncThrow } = useAsyncThrow();
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const updateCoveragePackageInformation = async (
        propertyToUpdate: Partial<T>
    ): Promise<void> => {
        const lob = getLobToUpdate(flavourName);
        const value = propertyToUpdate ?? getCoveragePackageFieldsToUpdate(coverable);
        if (value === undefined) return;

        const fieldToUpdate: CoveragePackageInformationToUpdateDTO = {
            productToUpdate: flavourName,
            [lob]: value
        };
        await OnlineSalesUnauthenticated.updateCoveragePackageInformation(
            jobNumber,
            lobCode,
            fixedId,
            fieldToUpdate,
            sessionId,
            !isLoggedOn
        ).catch(asyncThrow);
    };

    return { updateCoveragePackageInformation };
}
